import apiClient from './apiClient';

// F11A 測試項目主檔
export interface F11A {
  f11a_01: string;  // 測試代號
  f11a_11: string;  // 中文測試名稱
  f11a_12: string;  // 查詢用
  f11a_13: string;  // 查詢用
  f11a_14: string;  // 英文測試名稱
  f11a_15: number;  // 輸出畫面格式 (1-5)
  f11a_16: number;  // 總項數
  f11a_20: string;
  f11a_21: number;
  f11a_90: number;  // 版本
  f11a_91: string;  // 修改狀態
  f11a_92: string | null;  // 修改日期
  f11a_93: string;  // 修改者
  details?: F11A1[];
}

// F11A1 測試項目明細
export interface F11A1 {
  f11a1_01: string;  // FK → F11A
  f11a1_02: number;  // 項次
  f11a1_11: string;  // 檢驗規範代號
  f11a1_12: string;  // 渤揚標準
  f11a1_91: string;
  f11a1_92: string | null;
  f11a1_93: string;
  spec_name?: string;  // F11N_11 resolved
}

// F11N 檢驗規範主檔
export interface F11N {
  f11n_01: string;  // 規範代號
  f11n_11: string;  // 規範名稱
}

export interface ListResponse {
  data: F11A[];
  total: number;
  page: number;
  size: number;
}

const BASE = '/api/test-item';

const testItemApi = {
  list(page = 1, size = 100, keyword = ''): Promise<ListResponse> {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    if (keyword) params.set('keyword', keyword);
    return apiClient.get(`${BASE}?${params}`).then(r => r.data);
  },

  get(code: string): Promise<F11A> {
    return apiClient.get(`${BASE}/${code}`).then(r => r.data);
  },

  create(master: Partial<F11A>, details: Partial<F11A1>[]): Promise<F11A> {
    return apiClient.post(BASE, { master, details }).then(r => r.data);
  },

  update(code: string, master: Partial<F11A>, details: Partial<F11A1>[]): Promise<F11A> {
    return apiClient.put(`${BASE}/${code}`, { master, details }).then(r => r.data);
  },

  delete(code: string): Promise<void> {
    return apiClient.delete(`${BASE}/${code}`);
  },

  copy(sourceCode: string, newCode: string): Promise<F11A> {
    return apiClient.post(`${BASE}/${sourceCode}/copy`, { new_code: newCode }).then(r => r.data);
  },

  lookupSpec(code: string): Promise<{ code: string; name: string }> {
    return apiClient.get(`${BASE}/lookup/f11n/${code}`).then(r => r.data);
  },

  listSpecs(): Promise<{ data: F11N[] }> {
    return apiClient.get(`${BASE}/specs`).then(r => r.data);
  },
};

export default testItemApi;
